
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/aiTermsAndConditions/aiTermsAndConditions.scss.css.virtualfile';
        module.exports = {"text":"_text_y2n1q_1"};